import React, { useEffect, useRef, useState } from 'react';
import './styles.css';

interface OptionProps extends React.ComponentPropsWithoutRef<'option'> {
    value: string | number
    label: string
}

interface Props extends React.ComponentPropsWithoutRef<'select'> {
    options: OptionProps[]
    label?: string
    placeholder?: string
    className?: string
    loadData?: (event: React.ChangeEvent<HTMLSelectElement> | string) => void
}

const AppOption = (props: OptionProps) => (
    <option {...props}>{props.label}</option>
)

const AppSelect = ({
    label,
    placeholder = '',
    loadData,
    options,
    name,
    className,
    ...rest
}: Props) => {
    const selectRef = useRef<HTMLSelectElement>(null)
    const [initialValue, setInitialValue] = useState<string | number>('')

    useEffect(() => {
        if (selectRef.current && loadData && options.length > 0) {
            const selectedValue = selectRef.current.value
            if (selectedValue !== initialValue) {
                setInitialValue(selectedValue)
                loadData(selectedValue)
            }
        }
    }, [options, loadData, initialValue])

    return (
      <label className={'flex flex-col text-left text-sm text-shark-800 w-full'}>
            {label}
            <div className={`select relative ${label ? 'mt-1' : ''}`}>
                <select
                    name={name}
                    ref={selectRef}
                    value={rest.value ?? ''}
                    onChange={rest.onChange}
                    className={`w-full outline-none cursor-pointer ${className}`}
                >
                    {placeholder !== '' && (
                        <AppOption value={''} label={placeholder} disabled />
                    )}
                    {options.map((o, index) => (
                        <AppOption
                            key={index}
                            value={o.value}
                            label={o.label}
                            disabled={o.disabled}
                        />
                    ))}
                </select>
            </div>
        </label>
    )
}

export default AppSelect
